import { render, staticRenderFns } from "./PerfiosSuccess.vue?vue&type=template&id=22a44b0a&scoped=true&"
import script from "./PerfiosSuccess.vue?vue&type=script&lang=js&"
export * from "./PerfiosSuccess.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/style/base.css?vue&type=style&index=0&id=22a44b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a44b0a",
  null
  
)

export default component.exports